import React from 'react';
import { ModelOutlineColor, DrawingColor } from 'patternx-svg';
import classNames from 'classnames';
import styles from './index.module.less';

interface props {
  onItemClick: (data?: any) => void;
  datas: ELEMENT.modelFiles[];
  activeData: ELEMENT.modelFiles;
}

export default React.memo((props: props) => {
  const { datas, onItemClick, activeData } = props;

  return (
    <div className={styles.changeList}>
      <div className={styles.title}>切换查看</div>
      <ul className={styles.list}>
        <li
          className={classNames(styles.item, {
            [styles.active]: activeData?.storageFileId === 'model',
          })}
          onClick={() => onItemClick()}
        >
          <ModelOutlineColor />
          <span className={styles.name}>模型</span>
        </li>
        {datas?.map((d: ELEMENT.modelFiles) => (
          <li
            className={classNames(styles.item, {
              [styles.active]: activeData?.storageFileId === d.storageFileId,
            })}
            key={d.storageFileId}
            onClick={() => onItemClick(d)}
            title={`${d.name}.${d.outputType}`}
          >
            <DrawingColor />
            <span className={styles.name}>{`${d.name}.${d.outputType}`}</span>
          </li>
        ))}
      </ul>
    </div>
  );
});
